import { AnyAction } from 'redux';
import {
  MARKETPLACE_PRODUCT_REQUEST,
  MARKETPLACE_PRODUCT_SUCCESS,
  MARKETPLACE_PRODUCT_FAILURE,
  MARKETPLACE_PRODUCT_LIST_REQUEST,
  MARKETPLACE_PRODUCT_LIST_FAILURE,
  MARKETPLACE_PRODUCT_LIST_SUCCESS,
  MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST,
  MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS,
  MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE,
  MARKETPLACE_RESET,
} from './marketplace-constants';
import { MarketplaceState } from '../../types/types';

export const initialState: MarketplaceState = {
  // TODO: store each product in products state based on it's id to prevent requesting products multiple times when going between products and back again
  products: {}, // TODO: not used yet
  product: { loading: false, ready: false, error: null, data: {} }, // TODO: remove once products is used instead
  productList: { loading: false, ready: false, error: null, data: {} },
  mTrackConsent: { loading: false, ready: false, error: null, data: {} },
};

export const marketplaceReducer = (state: MarketplaceState = initialState, action: AnyAction): any => {
  switch (action.type) {
    case MARKETPLACE_PRODUCT_REQUEST:
      return { ...state, product: { loading: true, ready: false } };
    case MARKETPLACE_PRODUCT_SUCCESS:
      return { ...state, product: { data: action.payload.data.product, loading: false, ready: true, error: false } };
    case MARKETPLACE_PRODUCT_FAILURE:
      return { ...state, product: { error: action.response, loading: false, ready: true } };
    case MARKETPLACE_PRODUCT_LIST_REQUEST:
      return { ...state, productList: { loading: true, ready: false, error: null } };
    case MARKETPLACE_PRODUCT_LIST_SUCCESS:
      return { ...state, productList: { data: action.payload.data.productlist, loading: false, ready: true, error: false } };
    case MARKETPLACE_PRODUCT_LIST_FAILURE:
      return { ...state, productList: { error: action.response, loading: false, ready: true } };
    case MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST:
      return { ...state, mTrackConsent: { loading: true, ready: false, error: null } };
    case MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS:
      return { ...state, mTrackConsent: { data: action.payload.data, loading: false, ready: true } };
    case MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE:
      return { ...state, mTrackConsent: { error: action.payload, loading: false, ready: true } };
    case MARKETPLACE_RESET:
      return initialState;
    default:
      return state;
  }
};
